import styled from "styled-components";

const AlternativeLogo = styled.div<{ src: string | undefined; size?: string }>`
  height: ${props => props.size ?? "80px"};
  width: ${props => props.size ?? "80px"};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  :before {
    content: " ";
    display: block;
    position: absolute;
    height: ${props => props.size ?? "80px"};
    width: ${props => props.size ?? "80px"};
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${props => props.src});
  }
`;

export default AlternativeLogo;
